import {BehaviorSubject, combineLatest, Observable, of as observableOf, of, ReplaySubject} from 'rxjs';
import {Inject, Injectable} from '@angular/core';
import {DeviceId, NotificationId, NotificationScope, UserId} from '@webmate-web-core/shared/types/ids';
import {UserNotificationApi} from "@webmate-web-core/shared/api/rest/usernotification.restapi";
import {GenericApiResponse} from "@webmate-web-core/shared/api/apibase.api";
import {filter, tap, take} from "rxjs/operators";
import {EventsService} from "@webmate-web-core/shared/services/events/events.service";
import {DateTime} from '@webmate-web-core/shared/types/base-types';
import {ChannelInfo, Topic, UserNotification} from "@webmate-web-core/shared/types/notification";

@Injectable({
    providedIn: 'root',
})
export class UserNotificationService {

    private _notificationCenterNotifications$ = new BehaviorSubject<Array<UserNotification>>([]);

    constructor(private notificationApi: UserNotificationApi, private eventService: EventsService) {
        this.fetchNotifications();
        this.eventService.getAllEvents().pipe(filter(ev => ev.eventType.startsWith("Notification.Added"))).subscribe(ev => {
            this.fetchNotifications();
        })
    }

    fetchNotifications() {
        this.notificationApi.getNotifications$('notification-center').subscribe(result => {
            this._notificationCenterNotifications$.next(result);
        });
    }

    addNotification$(scope: NotificationScope, topic: Topic, title: string, text: string): Observable<NotificationId> {
        return this.notificationApi.addNotification$(scope, topic, title, text).pipe(tap(_ => this.fetchNotifications()));
    }

    observeNotificationCenterNotifications$(): Observable<Array<UserNotification>> {
        return this._notificationCenterNotifications$.asObservable();
    }

    getNotificationCenterNotifications$(): Observable<Array<UserNotification>> {
        return this._notificationCenterNotifications$.pipe(take(1));
    }

    getChannelInfo$(channelName: string): Observable<ChannelInfo> {
        return this.notificationApi.getChannelInfo$(channelName);
    }

    markChannelSeen$(channelName: string, seen: DateTime): Observable<GenericApiResponse> {
        return this.notificationApi.markChannelSeen$(channelName, seen).pipe(
            tap(_ => this.fetchNotifications()),
            take(1));
    }

    setTopicFilter(channelName: string, topics: Array<Topic>){
        return this.notificationApi.setTopicFilter(channelName, topics);
    }
}
